define('drops/dateInput/dateInput',[
    'jquery',
    'underscore',
    'require',
    'globalize',
    'lq/drop',
    'lq/style',
    'lq/enum',
    'lq/constants',
    'lq/responsive',
    'lq/util',
    'lq',
    'lq/zebra/zebra_datepicker',
    'jquery.timepicker',
    'lq/required'
], function ($, _, require, globalize, Drop, Style, Enum, constants, responsive, util, lq, zebraDatepicker, timepicker, Required) {
    'use strict';

    var defaults = {
        data: {
            showDatePicker: true,
            showTimePicker: false,
            todayLabel: 'Today',
            clearLabel: 'Clear',
            timeInputStep: 30,
            required: {
                initialVisibility: true,
                isRequired: false,
                valueSource: 'hardcoded'
            },
            precision: 'day',
            defaultMonth: 1,
            defaultDay: 1,
            defaultDaySource: 'hardcoded',
            defaultMonthSource: 'hardcoded'
        }
    };

    var dateChanged = function (date1, date2) {
        if (!date1 || !date2)
            return date1 !== date2;

        return date1.getYear() !== date2.getYear()
            || date1.getMonth() !== date2.getMonth()
            || date1.getDate() !== date2.getDate();
    };

    var timeChanged = function (date1, date2) {
        if (!date1 || !date2)
            return date1 !== date2;

        return date1.getHours() !== date2.getHours()
            || date1.getMinutes() !== date2.getMinutes()
            || date1.getSeconds() !== date2.getSeconds();
    };

    var formatTypes = new Enum("FormatType", ["Date", "Time"]);

    function DateInput(options) {
        Drop.call(this, $('<div/>'), defaults, options);

        this.data.eventing = util.convertListOfKeyValuesToObject(this.data.eventing) || {};

        this.date = null;
        this.inputFocusLostTimeout = null;

        this.$dateInput = $('<input type="text" />')
            .addClass('date-picker')
            .css({
                width: '100%',
                height: '100%',
                display: 'inline-block'
            })
            .attr('tabindex', this.data.tabIndex)
			.attr('placeholder', this.data.watermark)
            .addClass('boxToBorderSize')
            .on('blur', this.onDateInputBlur.bind(this))
            .on('focus', this.cancelFocusLost.bind(this))
            .appendTo(this.$element);

        if (this.data.showTimePicker) {
            this.$timeInput = $('<input type="text" />')
                .css({
                    display: 'inline-block',
                    position: 'absolute',
                    right: 0,
                    bottom: 0,
                    width: '102px',
                    height: '100%'
                })
                .attr('tabindex', -1)
                .appendTo(this.$element);
        }

        this.$element
	        .addClass('boxToBorderSize')
	        .css({
	            whiteSpace: 'pre-wrap'
	        });

        Style.renderStyles(this, null, this.$dateInput);
    }

    Drop.extend(DateInput, Drop);

    DateInput.typeName = 'DateInput';

    DateInput.prototype.minMaxDateFormat = 'yyyy-MM-dd';

    DateInput.prototype.preRender = function () {
        this.piping.visibility.apply(this);
        this.piping.required.apply(this);
        Required.prototype.addRemoveRequiredIndicator(this);

        this.formatter = this.piping.formatting.createFormatter(this.data.formatting);
        this.dateOnlyPhpFormat = this.filterAndConvertDateTimeFormat(this.formatter.dateFormat, formatTypes.Date);
        this.timeOnlyPhpFormat = this.filterAndConvertDateTimeFormat(this.formatter.dateFormat, formatTypes.Time);

        if (this.data.precision !== 'day') {
            this.dateOnlyPhpFormat = this.dateOnlyPhpFormat
                .replace(/[jdDL]/g, '');

            if (this.data.precision !== 'month') {
                this.dateOnlyPhpFormat = this.dateOnlyPhpFormat
                    .replace(/[nmMF]/g, '');
            }
        }

        this.applyPosition();
    };

    DateInput.prototype.postRender = function () {
        if (this.data.showDatePicker)
            this.attachDatePicker();

        if (this.data.showTimePicker)
            this.attachTimePicker();
    };

    DateInput.prototype.cancelFocusLost = function () {
        if (this.inputFocusLostTimeout !== null)
            clearTimeout(this.inputFocusLostTimeout);
    };

    var datePatternToPhpMap = {
        yy: 'y',
        yyyy: 'Y',
        M: 'n',
        MM: 'm',
        MMM: 'M',
        MMMM: 'F',
        d: 'j',
        dd: 'd',
        ddd: 'D',
        dddd: 'L'
    };

    var timePatternToPhpMap = {
        h: 'g',
        H: 'G',
        hh: 'h',
        HH: 'H',
        mm: 'i',
        ss: 's',
        tt: 'A',
        zzz: 'P'
    };

    /*jslint regexp: true */
    DateInput.prototype.filterAndConvertDateTimeFormat = function (dateTimeFormat, formatTypeToFilter) {
        var lastKnownType;
        var currentMap = formatTypeToFilter === formatTypes.Time ? timePatternToPhpMap : datePatternToPhpMap;

        return dateTimeFormat
            .replace(/(.)\1*/g, function (sameCharGroup) {
                var currentType = datePatternToPhpMap[sameCharGroup] ? formatTypes.Date :
                    timePatternToPhpMap[sameCharGroup] ? formatTypes.Time :
                    undefined;

                var result = (currentType || lastKnownType) === formatTypeToFilter ?
                    currentMap[sameCharGroup] || sameCharGroup : '';

                lastKnownType = currentType || lastKnownType;
                return result;
            });
    };
    /*jslint regexp: false */

    DateInput.prototype.attachDatePicker = function () {
        var self = this;

        this.createDateButton();

        if (this.data.readOnly) {
            this.$dateInput
                .prop('readonly', true);

            this.$dateIcon
                .css({
                    cursor: 'default'
                });
        } else {
            var deviceType = responsive.getDeviceType();
            var showAtFixedLocation = deviceType === constants.deviceTypes.Phone || (deviceType === constants.deviceTypes.Tablet && window.matchMedia("(orientation: portrait)").matches);
            
            this.minDateFormatted = globalize.parseDate(this.data.minDate, this.minMaxDateFormat);
            this.maxDateFormatted = globalize.parseDate(this.data.maxDate, this.minMaxDateFormat);
            this.$dateInput
                .Zebra_DatePicker({
                    days: this.formatter.culture.calendar.days.names,
                    days_abbr: this.formatter.culture.calendar.days.namesAbbr,
                    months: this.formatter.culture.calendar.months.names,
                    months_abbr: this.formatter.culture.calendar.months.namesAbbr,
                    show_icon: false,
                    format: this.dateOnlyPhpFormat,
                    readonly_element: showAtFixedLocation,
                    zero_pad: false,
                    show_select_today: this.data.todayLabel,
                    lang_clear_date: this.data.clearLabel,
                    onSelect: function (dateFormatted, dateStandard, dateObj) {
                        if (self.data.precision !== 'day') {
                            var day = self.data.defaultDay;
                            var month = self.data.defaultMonth;

                            if (self.data.defaultMonthSource === 'parameter' && self.data.monthParameter) {
                                month = self.piping.parameters.locals.getValue(self.data.monthParameter);
                            }

                            if (self.data.defaultDaySource === 'parameter' && self.data.dayParameter) {
                                day = self.piping.parameters.locals.getValue(self.data.dayParameter);
                            } else if (self.data.defaultDaySource === 'lastday') {
                                day = new Date(dateObj.getYear(), self.data.precision === 'month' ? dateObj.getMonth() + 1 : month, 0).getDate();
                            }

                            if (self.data.precision !== 'month') {
                                dateObj.setMonth(month - 1);
                            }
                            dateObj.setDate(day);
                        }

                        dateObj.setHours(0, 0, 0, 0);
                        var minMaxFlag = true;
                        if (self.data.minDate && dateObj) {
                            if (self.minDateFormatted && dateObj < self.minDateFormatted) {
                                minMaxFlag = false;
                                self.triggerEventIfEnabled('minMaxDateNotValid');
                            }
                        }
                        if (self.data.maxDate && dateObj) {
                            if (self.maxDateFormatted && dateObj > self.maxDateFormatted) {
                                minMaxFlag = false;
                                self.triggerEventIfEnabled('minMaxDateNotValid');
                            }
                        }
                        if (minMaxFlag) {
                            //Stop clickthrough so Modal doesn't close when clicked on modal background
                            $('.Zebra_DatePicker').on('click', function (e) {
                                e.stopImmediatePropagation();
                            });

                            var valueChanged = dateChanged(self.date, dateObj);

                            if (valueChanged) {
                                self.date = dateObj;
                                self.dateFormatted = dateFormatted;
                                if (self.data.precision !== 'day') {
                                    self.$dateInput.val(self.formatter.formatDate(dateObj));
                                }
                            }

                            self.cancelFocusLost();
                            self.updateRequiredIndicator();

                            if (self.data.showTimePicker)
                                self.$timeInput.timepicker('show');

                            var licquidDate = self.getCurrentDateAsLicquidDate();

                            if (licquidDate) {
                                self.triggerEventIfEnabled('selected', licquidDate);
                                self.triggerEventIfEnabled('dateSelected', licquidDate);
                            };

                            if (valueChanged) {
                                self.triggerEventIfEnabled('changed', licquidDate);
                                self.triggerEventIfEnabled('dateChanged', licquidDate);
                            }
                        } else {
                            self.dateUpdated(null);
                        }
                    },
                    onClear: function () {
                        if (self.date === null)
                            return;

                        self.date = null;
                        self.cancelFocusLost();
                        self.updateRequiredIndicator();

                        self.triggerEventIfEnabled('deselected');
                        self.triggerEventIfEnabled('changed');
                        self.triggerEventIfEnabled('dateChanged');
                    },
                    onOpen: function () {
                        self.cancelFocusLost();

                        if (showAtFixedLocation) {
                            var currentDimensions = $(".Zebra_DatePicker").css(["width", "height", "margin-left"]);
                            var currentBodyHeight = $(".Zebra_DatePicker .dp_body.dp_daypicker").css("height");
                            var currentDimensionsNumbers = {
                                width: Number(currentDimensions.width.substring(0, currentDimensions.width.length - 2)),
                                height: Number(currentDimensions.height.substring(0, currentDimensions.height.length - 2)),
                                bodyHeight: Number(currentBodyHeight.substring(0, currentBodyHeight.length - 2)),
                                margin: Number(currentDimensions["margin-left"].substring(0, currentDimensions["margin-left"].length - 2)),
                            }

                            var newWidth = window.innerWidth - (2 * currentDimensionsNumbers.margin);
                            var newBodyHeight = newWidth * (currentDimensionsNumbers.bodyHeight / currentDimensionsNumbers.width);
                            var newMargin = currentDimensionsNumbers.margin == 0 ? "auto" : currentDimensionsNumbers.margin + "px";
                            if ((newBodyHeight + currentDimensionsNumbers.height - currentDimensionsNumbers.bodyHeight) > (window.innerHeight - 150)) {
                                newBodyHeight = window.innerHeight - 150 - currentDimensionsNumbers.height + currentDimensionsNumbers.bodyHeight;
                                newWidth = newBodyHeight * (currentDimensionsNumbers.width / currentDimensionsNumbers.bodyHeight);
                                newMargin = ((window.innerWidth - newWidth) / 2) + "px";
                            }

                            $(".Zebra_DatePicker").
                                css({
                                    width: newWidth + 'px !important',
                                    margin: '0 ' + newMargin + ' 0 ' + newMargin,
                                    position: 'fixed',
                                    top: 'auto',
                                    bottom: 0
                                });
                            $(".Zebra_DatePicker .dp_body:not([style*=none])")
                                .css({
                                    height: newBodyHeight + 'px !important'
                                });
                            $(".Zebra_DatePicker .dp_body[style*=none]")
                                .css({
                                    height: newBodyHeight + 'px !important',
                                    display: 'none'
                                });
                        }
                        else {
                            var styleSplit = $(".Zebra_DatePicker").attr("style").split(/;/g);
                            if (styleSplit.some(function (element) { return element.includes("margin"); }) && styleSplit.some(function (element) { return element.includes("left"); }) && styleSplit.some(function (element) { return element.includes("top"); })) {
                                var left = styleSplit.find(function (element) { return element.includes("left"); });
                                var top = styleSplit.find(function (element) { return element.includes("top"); });
                                $(".Zebra_DatePicker").attr("style", left + "; " + top + ";");
                                $(".Zebra_DatePicker .dp_body:not([style*=none])").attr("style", "");
                                $(".Zebra_DatePicker .dp_body[style*=none]").attr("style", "display: none;");
                            }
                        }
                    }
                });

            this.zebra = this.$dateInput
                .data('Zebra_DatePicker');

            if (this.data.popupStyleId)
                this.zebra.datepicker.addClass('dateinputstyle-' + this.data.popupStyleId);

            this.$dateIcon
                .on('click', function() { self.zebra.show(); });
        }
    };

    DateInput.prototype.attachTimePicker = function () {
        var self = this;

        this.$timeInput
            .css('visibility', 'hidden');

        this.createTimeButton();

        if (!this.data.readOnly) {
            this.$timeButton
                .css({
                    cursor: 'pointer'
                })
                .on('click', function () {
                    self.$timeInput.timepicker('show');
                });

            this.$timeInput.timepicker({
                timeFormat: this.timeOnlyPhpFormat,
                step: this.data.timeInputStep,
                useSelect: false,
                noneOption: false
            });

            this.$timeInput
                .on('change', function () {
                    var newTime = self.$timeInput.timepicker('getTime', self.date);

                    self.dateUpdated(newTime);

                    // the time selection popup seems to be doing something really strange with the click event:
                    // triggering an event will show the ui blocker and this ui blocker will prevent
                    // the click event from propagating => the time selection popup will stay open
                    self.$timeInput.timepicker('hide');
                })
                .on('showTimepicker', this.cancelFocusLost.bind(this))
                .on('hideTimepicker', function () {
                    var licquidDate = self.getCurrentDateAsLicquidDate();
                    self.$dateInput.val(self.formatter.convertFromLicquidFormat(constants.valueTypes.dateTime, licquidDate));
                });
        }
    };

    DateInput.prototype.createTimeButton = function () {
        this.$timeButton = $('<span>')
            .css({
                backgroundImage: 'url(' + require.toUrl('drops/dateInput/clock-face.png') + ')',
                position: 'absolute',
                border: 'none',
                padding: 0,
                backgroundPosition: 'center',
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                right: 5,
                top: '0px',
                display: 'inline-block',
                width: '20px',
                height: '100%'
            })
            .appendTo(this.$element);
        this.changeTimePickerIcon();
    };

    DateInput.prototype.createDateButton = function () {
        this.$dateIcon = $('<button class="Zebra_DatePicker_Icon Zebra_DatePicker_Icon_Inside">')
            .css({
                backgroundImage: 'url(' +  require.toUrl('drops/dateInput/date-icon.png') + ')',
                backgroundPosition: 'center',
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                right: this.data.showTimePicker ? 25 : 5,
                top: '0px',
                display: 'inline-block',
                width: '20px',
                height: '100%'
            })
            .appendTo(this.$element);
        this.changeDatePickerIcon();
    };

    DateInput.prototype.onDateInputBlur = function () {
        this.updateRequiredIndicator();
        this.handleFocusLost();
    };

    DateInput.prototype.handleFocusLost = function () {
        this.cancelFocusLost();

        var newDateFormatted = this.$dateInput.val();

        if (this.dateFormatted === newDateFormatted)
            return;

        var newDate = globalize.parseDate(newDateFormatted, this.formatter.dateFormat);

        // force loose date format
        if (!newDate)
            newDate = globalize.parseDate(newDateFormatted.replace(/\D/g, ''), this.formatter.looseDateFormat);

        if (this.date && !this.data.showDatePicker && this.data.showTimePicker) {
            newDate.setFullYear(this.date.getFullYear());
            newDate.setMonth(this.date.getMonth());
            newDate.setDate(this.date.getDate());
        }

        this.dateUpdated(newDate);
    };

    DateInput.prototype.dateUpdated = function (newDate) {
        var newDateWithoutTime = null;
        if (newDate) {
            newDateWithoutTime = new Date(newDate);
            if (this.data.showTimePicker) {
                newDateWithoutTime.setHours(0, 0, 0, 0);
            }
        }
        if (this.data.minDate && newDateWithoutTime) {
            if (this.minDateFormatted && newDateWithoutTime < this.minDateFormatted) {
                newDate = null;
                this.triggerEventIfEnabled('minMaxDateNotValid');
            }
        }
        if (this.data.maxDate && newDateWithoutTime) {
            if (this.maxDateFormatted && newDateWithoutTime > this.maxDateFormatted) {
                newDate = null;
                this.triggerEventIfEnabled('minMaxDateNotValid');
            }
        }
        if (newDate) {
            var hasTimeChange = timeChanged(this.date, newDate);
            var hasDateChange = dateChanged(this.date, newDate);

            this.date = newDate;

            this.dateFormatted = this.formatter.formatDate(newDate);
            this.$dateInput.val(this.dateFormatted);

            if (this.data.showTimePicker)
                this.$timeInput.timepicker('setTime', newDate);

            var licquidDate = this.formatter.formatLicquidDate(newDate);

            if (hasTimeChange || hasDateChange) {
                this.triggerEventIfEnabled('selected', licquidDate);
                this.triggerEventIfEnabled('changed', licquidDate);
            }

            if (hasTimeChange) {
                this.triggerEventIfEnabled('timeSelected', licquidDate);
                this.triggerEventIfEnabled('timeChanged', licquidDate);
            }

            if (hasDateChange) {
                this.triggerEventIfEnabled('dateSelected', licquidDate);
                this.triggerEventIfEnabled('dateChanged', licquidDate);
            }
        } else {
            if (this.date) {
                this.date = null;
                this.dateFormatted = null;
                this.triggerEventIfEnabled('deselected');
                this.triggerEventIfEnabled('changed');
                this.triggerEventIfEnabled('timeChanged');
                this.triggerEventIfEnabled('dateChanged');
            }

            this.$dateInput.val(null);

            if (this.data.showTimePicker)
                this.$timeInput.timepicker('setTime', null);
        }

        this.updateRequiredIndicator();

        var self = this;
        this.inputFocusLostTimeout = setTimeout(function () {
            // we consider the input and the calendar to be a single element
            // so when the calendar is opened we have to give it some time
            // to cancel the focus lost event of the input box
            if (self.isEventEnabled('focusLost')) {
                if (self.zebra.datepicker.hasClass('dp_hidden') && !$('.ui-timepicker-wrapper:visible').length && !self.$dateInput.is(':focus'))
                    self.triggerEvent(self.data.eventing.focusLost.raisedEventName);
            }

            self.inputFocusLostTimeout = null;
        }, 100);
    };

    DateInput.prototype.focus = function () {
        this.$dateInput.trigger('focus');
    };

    DateInput.prototype.getValue = function () {
        return this.getCurrentDateAsLicquidDate();
    };

    DateInput.prototype.clearValue = function () {
        this.date = null;
        this.dateFormatted = null;

        this.$dateInput.val(null);

        if (this.data.showTimePicker)
            this.$timeInput.timepicker('setTime', null);

        this.updateRequiredIndicator();
    };

    DateInput.prototype.setValue = function (update) {
        if (update.value) {
            this.date = globalize.parseDate(update.value, constants.licquidDateFormat);
            this.dateFormatted = this.formatter.formatDate(this.date);

            if (!this.data.showTimePicker)
                this.date.setHours(0, 0, 0, 0);
        } else {
            this.date = null;
            this.dateFormatted = null;
        }

        this.$dateInput.val(this.dateFormatted);

        if (this.data.showTimePicker)
            this.$timeInput.timepicker('setTime', this.date);

        this.updateRequiredIndicator();
    };

    DateInput.prototype.getCurrentDateAsLicquidDate = function () {
        if (!this.date) return null;
        return this.formatter.formatLicquidDate(this.date);
    };

    DateInput.prototype.getDatePickerImagePath = function () {
        if (this.data.physicalFileDatePicker)
            return lq.getTenantUploads(this.data.physicalFileDatePicker);

        // non-editable property used on generated images like default preloader on list
        if (this.data.cdnPath)
            return lq.getCdnUrl(this.data.cdnPath);

        return null;
    };

    DateInput.prototype.getTimePickerImagePath = function () {
        if (this.data.physicalFileTimePicker)
            return lq.getTenantUploads(this.data.physicalFileTimePicker);

        // non-editable property used on generated images like default preloader on list
        if (this.data.cdnPath)
            return lq.getCdnUrl(this.data.cdnPath);

        return null;
    };

    DateInput.prototype.changeDatePickerIcon = function () {
        var imagePath = this.getDatePickerImagePath();
        if (imagePath && this.data.useCustomIconDatePicker) {
            this.setImageDatePicker(imagePath);
        } else if (this.$dateIcon) {
            this.$dateIcon
            .css({
                backgroundImage: 'url(' +  require.toUrl('drops/dateInput/date-icon.png') + ')',
            });
        }
    }

    DateInput.prototype.changeTimePickerIcon = function () {
        var imagePath = this.getTimePickerImagePath();
        if (imagePath && this.data.useCustomIconTimePicker && this.$timeButton) {
            this.setImageTimePicker(imagePath);
        } else if (this.$timeButton) {
            this.$timeButton
                .css({
                    backgroundImage: 'url(' + require.toUrl('drops/dateInput/clock-face.png') + ')'
                })
        }
    }

    DateInput.prototype.setImageTimePicker = function(image) {
        this.$timeButton
            .css({
                backgroundImage: 'url(' +  require.toUrl(image) + ')'
            })
    };

    DateInput.prototype.setImageDatePicker = function(image) {
        this.$dateIcon
            .css({
                backgroundImage: 'url(' +  require.toUrl(image) + ')',
            })
    };

    return DateInput;
});

